module.exports = __webpack_public_path__ + "static/media/clock-icon.26840c4c.svg";